// Replace these values with your actual AWS resources
const awsmobile = {
    "aws_project_region": "us-west-2", 
    "aws_cognito_region": "us-west-2", 
    "aws_user_pools_id": "us-west-2_TSOy7pu6R", // Replace with your Cognito User Pool ID
    "aws_user_pools_web_client_id": "tcsoi579h296leirckhdocjqr", // Replace with your App Client ID
    "aws_cognito_identity_pool_id": "us-west-2:c9abf28d-8a06-4140-a9f1-284b85791c30", // Add this line with your actual Identity Pool ID
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "erikaandrew_wedding",
            "region": "us-west-2"
        }
    ]
};

export default awsmobile;